<template>
  <div class="list-group-item ">
    <div class="row align-items-center">
      <div class="col-auto">
        <slot name="icon"></slot>
      </div>
      <div class="col">
        <h5 class="mb-0 fw-bold">
          <slot name="title"></slot>
        </h5>
      </div>
    </div>
  </div>
</template>